import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import getters from './getters';
import mutations from './mutations';

export const serviceComputed = {
	...mapGetters('pqPprRptSttsStore', Object.keys(getters)),
	...mapState('pqPprRptSttsStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('pqPprRptSttsStore', Object.keys(actions)),
	...mapMutations('pqPprRptSttsStore', Object.keys(mutations))
};
